import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { ItemLink } from "../ItemLink";

interface ItemCardProps {
  itemId: number;
  isMainItem?: boolean;
  isMythic?: boolean;
  itemClass?: string;
  textClass?: string;
  showGold?: boolean;
}

export function ItemCard(props: ItemCardProps) {
  const { itemId, isMainItem, isMythic, itemClass, textClass, showGold = true } = props;

  const { useNewRiotItems } = getRiotAssetsContext();
  const { data } = useNewRiotItems({ itemId: itemId, ssr: true });
  const itemData = data?.[itemId];

  if (!itemData) {
    return <div></div>;
  }
  const name = itemData.name;
  const cost = itemData.gold.total;

  return (
    <div className="item-card">
      <div
        className={
          itemClass
            ? itemClass
            : isMainItem && isMythic
            ? "items-pic-medium items-border-mythic-small"
            : isMainItem
            ? "items-pic-medium items-border-normal-small"
            : "items-pic-small items-border-normal-small"
        }
      >
        <ItemLink itemId={itemId} />
      </div>
      <div className="item-card-info">
        <span className={textClass ? textClass : "text-default"}>{name}</span>
        {showGold && <GoldLogo cost={cost} />}
      </div>
    </div>
  );
}

export function GoldLogo(props: { cost: number }) {
  const { cost } = props;

  return (
    <div className="gold-logo">
      <img src="https://static.bigbrain.gg/assets/ugg/icons/gold-icon.svg" alt="gold-icon" />
      {cost}
    </div>
  );
}
